import React from "react";
import { HRProvider } from "../HRContext";
import ContractTypeList from "./ContractTypeList";

const ContractTypeListWrapper: React.FC = () => {
  return (
    <HRProvider>
      <ContractTypeList />
    </HRProvider>
  );
};

export default ContractTypeListWrapper;
